export default __webpack_public_path__ + "vision-examples-basic-ar-navigation-thumbnail-960-89a01b9df6b7eea98acbf833bb93cab2.webp";